import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TasacionArchivo } from '../models/TasacionArchivo';

@Injectable({
  providedIn: 'root'
})
export class ContratosService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getContratos() {
    return this.http.get(this.myAppUrl + 'api/Contratos');
  }

  getContratosConInactivos() {
    return this.http.get(this.myAppUrl + 'api/Contratos/ConInactivos');
  }

  searchContratos(idPrescriptor: any = '', idCliente: any = '') {
    const url = this.myAppUrl + 'api/Contratos/SearchContratos';
    let params = new HttpParams()
    .set('IdPrescriptor', idPrescriptor)
    .set('IdCliente', idCliente)

    return this.http.get(url, { params });
  }

  getContrato(id:number) {
    return this.http.get(this.myAppUrl +  'api/Contratos/' + id);
  }

  createContrato(contrato: any) {
    return this.http.put(this.myAppUrl + 'api/Contratos', contrato);
  }

  updateContrato(id:number,contrato:any) {
    return this.http.post(this.myAppUrl + 'api/Contratos',contrato);
  }

  getTipoContratos() {
    return this.http.get(this.myAppUrl + 'api/TipoContrato');
  }

  getTarifas() {
    return this.http.get(this.myAppUrl + 'api/Tarifa');
  }

  deleteContrato(id:number) {
    return this.http.delete(this.myAppUrl + 'api/Contratos/' + id); 
  }
}
